import Vue from "vue";
import Vuex from "vuex";
import Simulation from "../models/simulation";
const axios = require("axios").default;

const url = process.env.VUE_APP_STATS_URL;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    simulations: [],
    editableSimulation: new Simulation(null, [], {}, null, {}),
    simulationIsBeingEdited: false
  },
  getters: {
    areAllStatsLoaded: state => {
      return (
        state.simulations.filter(simulation => Boolean(simulation.stats)).length ===
        state.simulations.length
      );
    }
  },
  mutations: {
    setSimulationIsBeingEdited(state, isEdited) {
      state.simulationIsBeingEdited = isEdited;
    },
    addSimulation(state, simulation) {
      state.simulations.push(simulation);
    },
    setEditableSimulation(state, simulation) {
      state.editableSimulation = simulation;
    },
    addAttack(state, attack) {
      state.editableSimulation.attacks.push(attack);
    },
    removeAttack(state, attack) {
      const index = state.editableSimulation.attacks.indexOf(attack);
      state.editableSimulation.attacks.splice(index, 1);
    },
    addStatsToEditableSimulation(state, stats) {
      state.editableSimulation.stats = stats;
    },
    deleteSimulation(state, simulation) {
      const index = state.simulations.indexOf(simulation);
      state.simulations.splice(index, 1);
    }
  },
  actions: {
    endEditingSimulation(context) {
      context.commit("setSimulationIsBeingEdited", false);
    },
    addSimulation(context, simulation) {
      context.commit("addSimulation", simulation);
    },
    editSimulation(context, simulation) {
      context.commit("setEditableSimulation", simulation);
      context.commit("setSimulationIsBeingEdited", true);
    },
    addAttack(context) {
      const attack = {
        attack: { action: 3, power: 0 },
        damage: { action: 3, power: 0 }
      };
      context.commit("addAttack", attack);
    },
    removeAttack(context, attack) {
      context.commit("removeAttack", attack);
    },
    addStatsToEditableSimulation(context) {
      context.commit("addStatsToEditableSimulation", null);
      axios
        .post(url, context.state.editableSimulation)
        .then(function(response) {
          context.commit("addStatsToEditableSimulation", response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteSimulation(context, simulation) {
      context.commit("deleteSimulation", simulation);
    }
  },
  modules: {}
});
